
import { BARCODE_ORDER_MENU_ITEM } from "@/consts";
import BarcodeOrderTable from "@/components/barcodeSystem/barcodeOrder/BarcodeOrderTable.vue";
import BarcodeOrderFilters from "@/components/barcodeSystem/barcodeOrder/BarcodeOrderFilters.vue";
import BarcodeOrdersActions from "@/components/barcodeSystem/barcodeOrder/BarcodeOrdersActions.vue";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import Component from "vue-class-component";

const barcodeOrderModuleState = getModule(BarcodeOrderModule);

@Component({
  components: {
    BarcodeOrderTable,
    BarcodeOrderFilters,
    BarcodeOrdersActions
  }
})
export default class BarcodeOrderSearch extends Vue {
  showBarcodeOrderFieldFilter: boolean = false;
  truckMenuStyle: string = "";
  BARCODE_ORDER_MENU_ITEM: any = BARCODE_ORDER_MENU_ITEM;

  get fields() {
    return barcodeOrderModuleState.fields;
  }

  async created() {
  }
  
  async loadMoreOrders() {
    await barcodeOrderModuleState.setLoading(true);
    await barcodeOrderModuleState.getBarcodeOrders(null);
    await barcodeOrderModuleState.setLoading(false);
  }

  async onSort(s) {
    await barcodeOrderModuleState.setLoading(true);
    await barcodeOrderModuleState.applyListSort(s);
    await barcodeOrderModuleState.setLoading(false);
  }

  toggleChangeField(idx, hideShow) {
    barcodeOrderModuleState.toggleField({ idx: idx, value: !hideShow });
  }

  get menuItemsToDisplay() {
    return this.BARCODE_ORDER_MENU_ITEM.filter(
      x => x.requiresPermission === undefined || this.hasPermission(x.requiresPermission)
    );
  }

  get dataRetreived() {
    if(barcodeOrderModuleState.data)
      return true;
    return false;
  }
}


